const gender = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
];

export default gender;
